import axios from './base'

const url = {
  queryNote: '/api/search/notes',
  queryNotebook: '/api/search/notebooks',
  search: '/api/search'
}

export default {
  async queryNote ({ pageIndex, pageSize }) {
    return await axios.get(url.queryNote, {
      params: {
        pageIndex,
        pageSize
      }
    })
  },
  async queryNotebook ({ pageIndex, pageSize }) {
    return await axios.get(url.queryNotebook, {
      params: {
        pageIndex,
        pageSize
      }
    })
  },
  async search ({ fuzzy, text, tag, createdTime, modifiedTime, page, pageSize }) {
    return await axios.get(url.search, {
      params: {
        fuzzy,
        text,
        tag,
        createdTime,
        modifiedTime,
        page,
        pageSize
      }
    })
  }
}
